import { Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { CronGenComponent } from 'src/app/cron-editor-module/cron-editor.component';
import { CronOptions } from 'src/app/cron-editor-module/CronOptions';

@Component({
    selector: 'cron-form',
    templateUrl: './cron-form.component.html',
    styleUrls: ['./cron-form.component.scss'],
    standalone: false
})
export class CronFormComponent implements OnInit {

  
  public cronExpression = '0 0 1/1 * *';
  public isCronDisabled = false;
  
  public cronOptions: CronOptions = {
    formInputClass: 'form-control cron-editor-input',
    formSelectClass: 'form-control cron-editor-select',
    formRadioClass: 'cron-editor-radio',
    formCheckboxClass: 'cron-editor-checkbox',

    defaultTime: '00:00:00',

    hideMinutesTab: false,
    hideHourlyTab: false,
    hideDailyTab: false,
    hideWeeklyTab: false,
    hideMonthlyTab: false,
    hideYearlyTab: false,
    hideAdvancedTab: false,
    hideSpecificWeekDayTab: false,
    hideSpecificMonthWeekTab: false,

    use24HourTime: true,
    hideSeconds: false,

    cronFlavor: 'quartz'
  };

  @ViewChild('cronEditorDemo')
  cronEditorDemo: CronGenComponent;
  showButtons: boolean = true;
  cronForm: UntypedFormControl;

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>, @Inject(NZ_MODAL_DATA) public nzData) { }

  ngOnInit(): void {
    
    this.cronForm = new UntypedFormControl('0 0/1 * 1/1 * ? *');

    if ( this.nzData!= null ){
      
      this.showButtons = this.nzData.action.showButtons !== undefined ? this.nzData.action.showButtons : true;
      if ( this.nzData.action.value!= null && this.nzData.action.value!='' ){
        this.cronForm.setValue(this.nzData.action.value);
      }
    }
  }

  cronFlavorChange() {
    this.cronEditorDemo.options = this.cronOptions;
  }

  salvar(){
      this.data = this.cronForm.value;
      this.dialogRef.close(this.data);
  }
}
